import initialState from '../auth/initialState'
import { RESET_AUTH_DATA, SET_ACCESS_TOKEN } from './actionTypes'
import { del, set } from 'idb-keyval'

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_ACCESS_TOKEN:
      set('token', action.token)
      return {
        ...state,
        access_token: action.token
      }
    case RESET_AUTH_DATA:
      del('token')
      return {
        access_token: ''
      }
    default:
      return state
  }
}
